import React from "react";
const icon = (
  <svg
    width="448"
    height="512"
    viewBox="0 0 448 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 32C28.7 32 0 60.7 0 96V416C0 451.3 28.7 480 64 480H384C419.3 480 448 451.3 448 416V173.3C448 156.3 441.3 140 429.3 128L352 50.7C340 38.7 323.7 32 306.7 32H64ZM64 128C64 110.3 78.3 96 96 96H288C305.7 96 320 110.3 320 128V192C320 209.7 305.7 224 288 224H96C78.3 224 64 209.7 64 192V128ZM224 288C240.974 288 257.252 294.743 269.255 306.745C281.257 318.748 288 335.026 288 352C288 368.974 281.257 385.252 269.255 397.255C257.252 409.257 240.974 416 224 416C207.026 416 190.747 409.257 178.745 397.255C166.743 385.252 160 368.974 160 352C160 335.026 166.743 318.748 178.745 306.745C190.747 294.743 207.026 288 224 288Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
